import videojs from 'video.js';
import $ from 'jquery';
import {gen, icon, isDefined, isMobile, isEmpty} from '../Helpers';
import Player from '@vimeo/player';
import {EVENT_WINDOW_RESIZE, VIDEO_PLAYER_READY} from "../Paramaters";


export default class Section {
    constructor(props) {
        this.element =$(props.element);
        this.fullScreen = this.element.hasClass('fullScreen');
        this.events();
        this.init();
    }

    init(){
        this.set_size();


        if(this.element.attr('id') === 'customers'){
            this.init_customers();
        }


    }
    events() {
        $(window).on(EVENT_WINDOW_RESIZE, () => this.onResize());
    }

    onResize() {
        this.set_size();
    }

    set_size() {
        if(this.fullScreen) {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
        }
        this.element.css(this.style())
    }


    style() {
        return {
            width:this.width,
            height: this.height
        }
    }


    render(){

       // return (<section style={this.style()}></section>);
    }


    init_customers(){
        if(isMobile()){
            $('.customer').blur((e)=>{
                const elem = $(e.delegateTarget);
                elem.removeClass('open');
            });
            $('.customer').click((e)=>{
                const elem = $(e.delegateTarget);
                if(!elem.hasClass('open')){
                    e.preventDefault();
                    $('.customer').removeClass('open');
                    elem.addClass('open');
                }
            })

        }
    }

}





